'use client';

import type {
  CategoriesEntity,
  GeneralLayout,
  Menu,
} from '@eliadmin/core/src/api/general/types/general-layout-types';

import { HeaderMain } from '@eliadmin/core/src/components/header/header-main';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function MainHeader({
  whiteText,
  isHomepage,
  generalLayout,
  categories,
  mobileSidebarCategories,
  topbarMenu,
}: {
  whiteText: boolean;
  isHomepage: boolean;
  generalLayout: GeneralLayout['data'];
  categories: CategoriesEntity[];
  mobileSidebarCategories: CategoriesEntity[];
  topbarMenu: Menu;
}) {
  return (
    <div className={cn('relative', isHomepage && 'h-0')}>
      {/* `relative` is the positioning context for the category dropdown, which now hangs off the
          header row rather than off its own full-width nav line. Figma: 24px top / 12px bottom. */}
      <header
        className={cn(
          'custom-section',
          'relative left-0 right-0 top-0 flex w-full flex-col items-center justify-center pb-2.5 pt-3 transition-all sm:pt-4 lg:pb-3 lg:pt-6',
          whiteText ? 'bg-transparent' : 'bg-white',
          isHomepage ? 'absolute' : 'border-b',
        )}
      >
        <HeaderMain
          generalLayout={generalLayout}
          whiteText={whiteText}
          categories={categories}
          mobileSidebarCategories={mobileSidebarCategories}
          topbarMenu={topbarMenu}
        />
      </header>
    </div>
  );
}
